const DATE_INPUT_REGEXP = /^\d{2}\/\d{2}\/\d{4}$/;

function prependZeroIfOneDigit(number) {
    return number < 10 ? `0${number}` : String(number);
}

export function isValidDateInput(dateInput) {
    if (!dateInput) {
        return false;
    }

    if (!DATE_INPUT_REGEXP.test(dateInput)) {
        return false;
    }

    const installDateTimestamp = Date.parse(new Date(dateInput));
    const isValidDate = !isNaN(installDateTimestamp);

    return isValidDate;
}

export function dateInputToTimestamp(dateInput) {
    if (!isValidDateInput(dateInput)) {
        return '';
    }

    const [month, day, year] = dateInput.split('/');
    const monthAdjusted = Number(month) - 1;
    const dateObject = new Date(year, monthAdjusted, day);

    // set time to end of day of install date
    dateObject.setHours(23);
    dateObject.setMinutes(59);
    dateObject.setSeconds(59);

    return dateObject.toISOString();
}

export function timestampToInputString(timestamp) {
    const date = new Date(timestamp);
    const isValidDate = !isNaN(Date.parse(date));

    if (!timestamp || !isValidDate) {
        return '';
    }

    const monthValue = date.getMonth() + 1;
    const dateValue = date.getDate();
    const yearValue = date.getFullYear();

    return `${prependZeroIfOneDigit(monthValue)}/${prependZeroIfOneDigit(dateValue)}/${yearValue}`;
}
